var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactsTabSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "address book_01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "96.2278107%",
    y1: "100%",
    x2: "3.77218935%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5A33",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA98C",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PC\\u5207\\u56FE",
    transform: "translate(-91.000000, -107.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(91.000000, 107.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1153846,2 C23.2199541,2 24.1153846,2.8954305 24.1153846,4 L24.1153846,23 C24.1153846,24.1045695 23.2199541,25 22.1153846,25 L6.88461538,25 C5.78004588,25 4.88461538,24.1045695 4.88461538,23 L4.884,20.208 L2.95833333,20.2083333 C2.42906045,20.2083333 2,19.7792729 2,19.25 C2,18.7207271 2.42906045,18.2916667 2.95833333,18.2916667 L4.884,18.291 L4.884,14.458 L2.95833333,14.4583333 C2.42906045,14.4583333 2,14.0292729 2,13.5 C2,12.9707271 2.42906045,12.5416667 2.95833333,12.5416667 L4.884,12.541 L4.884,8.708 L2.95833333,8.70833333 C2.42906045,8.70833333 2,8.27927289 2,7.75 C2,7.22072711 2.42906045,6.79166667 2.95833333,6.79166667 L4.884,6.791 L4.88461538,4 C4.88461538,2.8954305 5.78004588,2 6.88461538,2 L22.1153846,2 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#FFFFFF",
    opacity: 0.8,
    x: 17.0384615,
    y: 8.19230769,
    width: 1.76923077,
    height: 10.6153846,
    rx: 0.884615385
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-4",
    fill: "#FFFFFF",
    opacity: 0,
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsTabSelected);
export default __webpack_public_path__ + "static/media/ContactsTabSelected.840ee3f9d11a5f6d620e0e6bc0adfea5.svg";
export { ForwardRef as ReactComponent };